import {filter, merge} from 'rxjs';
import {useEffect} from 'react';

import {Conversation} from '@stripe-internal/conversations-client';

import {useThreadsConversationViewModel} from '../app/hooks';

export function useThreadsConversationExceptions(
  conversation?: Conversation | null,
) {
  const viewModel = useThreadsConversationViewModel();

  useEffect(() => {
    if (!conversation) {
      return;
    }

    const {client} = conversation;

    const clientExceptions$ = client
      .eventsObservable()
      .pipe(filter((e) => e.name === 'client-exception'));
    const clientConversationExceptions$ = client
      .conversationEventsObservable()
      .pipe(filter((e) => e.name === 'conversation-exception'));
    const conversationExceptions$ = conversation
      .eventsObservable()
      .pipe(filter((e) => e.name === 'conversation-exception'));

    const sub = merge(
      clientExceptions$,
      clientConversationExceptions$,
      conversationExceptions$,
    ).subscribe((e) => {
      const cleanupAndShowError = () => {
        conversation.clearStorage();

        viewModel.setError({
          errorId: e.sentryEventId,
        });
      };

      if (conversation.client.channel === 'chat') {
        try {
          conversation
            .sendMessage(
              conversation.buildTextMessage(
                'Error: The user encountered a client error and has left the conversation.',
              ),
            )
            .then(cleanupAndShowError);
        } catch {
          cleanupAndShowError();
        }
      } else {
        cleanupAndShowError();
      }
    });

    return () => sub.unsubscribe();
  }, [conversation, viewModel]);
}
